//import Moment from "moment";

const getCount = (state) => {
	return state.entradasNF.length;
}

const ultimaAtualizacaoListaEntradaNF = (state) => {
	if (state.ultimaAtualizacaoListaEntradaNF == null) {
		return true;
	}
	else if(!state.entradasNF)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.entradasNF.length == 0 ||
			hour - state.ultimaAtualizacaoListaEntradaNF.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaEntradaNF
}